import type { ColumnDef } from '@tanstack/react-table'
import type { User } from '@/hooks/useUsers'
import { Badge } from '@/components/ui/badge'
import { CheckCircle2, Flag } from 'lucide-react'
import CopyButton from '@/components/common/CopyButton'

const statusColors = {
    Active: 'bg-green-100 text-green-700 hover:bg-green-100',
    Flagged: 'bg-red-100 text-red-700 hover:bg-red-100',
}

export const userColumns: ColumnDef<User>[] = [
    {
        accessorKey: 'id',
        header: 'User ID',
        cell: ({ row }) => (
            <span className="font-mono text-xs">#{row.original.id}</span>
        ),
    },
    {
        accessorKey: 'accountName',
        header: 'Account name',
        cell: ({ row }) => (
            <span className="text-sm">{row.original.accountName}</span>
        ),
    },
    {
        accessorKey: 'walletAddress',
        header: 'Wallet Address',
        cell: ({ row }) => (
            <div className="group inline-flex items-center">
                <span className="font-mono text-xs text-muted-foreground">
                    {row.original.walletAddress}
                </span>
                <CopyButton
                    className="ml-1"
                    text={row.original.walletAddress}
                />
            </div>
        ),
    },
    {
        accessorKey: 'email',
        header: 'Email',
        cell: ({ row }) => (
            <div className="group inline-flex items-center">
                <span className="text-sm text-muted-foreground">
                    {row.original.email}
                </span>
                <CopyButton className="ml-1" text={row.original.email} />
            </div>
        ),
    },
    {
        accessorKey: 'phoneNo',
        header: 'Phone no',
        cell: ({ row }) => (
            <div className="group inline-flex items-center">
                <span className="text-sm text-muted-foreground">
                    {row.original.phoneNo}
                </span>
                <CopyButton className="ml-1" text={row.original.phoneNo} />
            </div>
        ),
    },
    {
        accessorKey: 'dateJoined',
        header: 'Date joined',
        cell: ({ row }) => (
            <span className="text-sm text-muted-foreground">
                {row.original.dateJoined}
            </span>
        ),
    },
    {
        accessorKey: 'gender',
        header: 'Gender',
        cell: ({ row }) => (
            <span className="text-sm">{row.original.gender}</span>
        ),
    },
    {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ row }) => {
            const status = row.original.status
            return (
                <Badge variant="secondary" className={statusColors[status]}>
                    {status === 'Flagged' && <Flag className="mr-1 h-3 w-3" />}
                    {status === 'Active' && (
                        <CheckCircle2 className="mr-1 h-3 w-3" />
                    )}
                    {status}
                </Badge>
            )
        },
    },
]
